import React, { useState } from "react";
import Form from "../../Components/Form";
import DynamicDropdown from "../../Components/Dropdown/DynamicDropdown";
import { IConversionSearchParam } from "../../Interfaces/conversion";
import { getBaseInstruments } from "../../Requests/Order/tradeTableRequests";
import TextInput from "../../Components/TextInput";
import Button from "../../Components/Button";
import ConversionTable from "../../Tables/Conversion/ConversionTable";
import useSearchParam from "../../Hooks/useSearchParam";

const Conversion = () => {
  const {
    clientSearchParamChangeHandler,
    clientSearchParams,
    onSubmit,
    serverSearchParams,
  } = useSearchParam({
    initialSearchParam: {} as IConversionSearchParam,
  });

  return (
    <div className="flex flex-row justify-start items-start gap-12 mt-10 py-10">
      <Form className="!w-56 min-w-[224px] py-2 px-3 gap-3 mr-5">
        <DynamicDropdown
          dropdown={{
            name: "insCode",
            placeholder: "نماد",
          }}
          onChange={clientSearchParamChangeHandler}
          value={clientSearchParams.insCode}
          getData={() => getBaseInstruments()}
        />
        <TextInput
          label="حداقل روز باقی مانده"
          name="minRemainingDay"
          value={clientSearchParams.minRemainingDay?.toString()}
          onChange={clientSearchParamChangeHandler}
          kind="number"
        />

        <TextInput
          label="حداقل سود مارکت مارکت"
          name="minCallMarketPutMarket"
          value={clientSearchParams.minCallMarketPutMarket?.toString()}
          onChange={clientSearchParamChangeHandler}
          kind="priceWithDecimal"
        />
        <TextInput
          label="حداقل سود لیمیت مارکت"
          name="minCallLimitPutMarket"
          value={clientSearchParams.minCallLimitPutMarket?.toString()}
          onChange={clientSearchParamChangeHandler}
          kind="priceWithDecimal"
        />
        <TextInput
          label="حداقل سود مارکت لیمیت"
          name="minCallMarketPutLimit"
          value={clientSearchParams.minCallMarketPutLimit?.toString()}
          onChange={clientSearchParamChangeHandler}
          kind="priceWithDecimal"
        />
        <TextInput
          label="حداقل سود لیمیت لیمیت"
          name="minCallLimitPutLimit"
          value={clientSearchParams.minCallLimitPutLimit?.toString()}
          onChange={clientSearchParamChangeHandler}
          kind="priceWithDecimal"
        />
        <TextInput
          label="سود هدف"
          name="targetProfit"
          value={clientSearchParams.targetProfit?.toString()}
          onChange={clientSearchParamChangeHandler}
          kind="priceWithDecimal"
        />
        <Button text="جستجو" onClick={onSubmit} variant="contained" />
      </Form>

      <ConversionTable searchParams={serverSearchParams} />
    </div>
  );
};

export default Conversion;
